import React from "react";


export default function SectionPanel({ sections }) {
    return (
        <div className="space-y-4">
            {sections?.map((s) => (
                <div key={s.key} className="bg-gray-50 p-4 rounded-lg">
                    <div className="flex items-center justify-between mb-3">
                        <h4 className="font-medium text-gray-900">{s.title}</h4>
                        <div className="flex items-center space-x-2">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${s.score === "4/4" ? "text-green-600 bg-green-50" : "text-yellow-600 bg-yellow-50"}`}>
                                {s.score}
                            </span>
                            {s.score !== "4/4" && (
                                <button type="button" className="text-blue-600 hover:text-blue-700 text-xs">Override</button>
                            )}
                        </div>
                    </div>


                    <p className="text-sm text-gray-600 mb-3">{s.summary}</p>


                    <div>
                        <div>
                            <span className="text-sm font-medium text-gray-800">AI Assessment:</span>
                            <p className="text-sm text-gray-600 mt-1">{s.assessment}</p>
                        </div>


                        <div className="mt-2">
                            <span className="text-sm font-medium text-gray-800">Evidence:</span>
                            <ul className="text-sm text-gray-600 mt-1 space-y-1">
                                {s.evidence?.map((ev, i) => (
                                    <li key={i} className="flex items-start space-x-2">
                                        <span className="w-1 h-1 bg-gray-400 rounded-full mt-2" />
                                        <span>{ev}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}